import { pageContext } from 'ctm-util-functions';

import reducer from './reducers';
import { models, builders, factories } from './models';

import { getServerConfig } from '../config/config_loader';
import * as verticalComponents from '../components';
import * as verticalCss from '../css';
import * as verticalSelectors from './state_selectors';
import * as verticalJSON from '../json';
import { verticalSagas } from './sagas';

let preloadSchemas = {};

if (!process.env.CLIENT) {
    // eslint-disable-next-line global-require
    preloadSchemas = require('../schemas/preload').default;
}

const title = 'home-contents-insurance';

const allPages = models.pageSchemaModel.getAllSchemas();

// This is a fail-safe for when we need to access models, builders etc before PageBuilder has run for the first
// time. This sets up all of the 'static' props (ie props that don't change on each page load) except for the
// director.
pageContext.setProps({
    allPages,
    builders,
    factories,
    models,
    verticalComponents,
    verticalCss,
    verticalSelectors,
    verticalJSON,
    verticalSagas,
    preloadSchemas,
    valueMap: models.formSchemaModel.valueMap
});

const snippets = models.snippetModel;

const app = {
    reducer,
    snippets,
    title,
    preloadSchemas,
    models,
    stateSelectors: verticalSelectors, // @todo remove this from appConfig
    getServerConfig
};

export { app };
